import { render, staticRenderFns } from "./SourcesEditor.vue?vue&type=template&id=8d554672&scoped=true&"
import script from "./SourcesEditor.vue?vue&type=script&lang=js&"
export * from "./SourcesEditor.vue?vue&type=script&lang=js&"
import style0 from "./SourcesEditor.vue?vue&type=style&index=0&id=8d554672&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d554672",
  null
  
)

export default component.exports